import {Component, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {ContentHeader} from "app/layout/components/content-header/content-header.component";


@Component({
  selector: 'app-returns-warranties',
  templateUrl: './returns-warranties.component.html',
  styleUrls: ['./returns-warranties.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ReturnsWarrantiesComponent implements OnInit, OnDestroy {

  public contentHeader: ContentHeader

  public topic:any;

  constructor() {
  }

  ngOnInit(): void {
    this.contentHeader = {
      headerTitle: 'Resi e Garanzie',
      actionButton: false,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/home'
          },
          {
            name: 'Resi e Garanzie',
            isLink: false
          }
        ]
      }
    };

    this.topic = {
      icon: 'credit-card',
      title: 'Resi e Garanzie',
      subtitle: 'Gentile cliente, se ha intenzione di inviarci un reso non conforme o in garanzia, può seguire le seguenti istruzioni',
      qanda: [
        {
          question: 'Documenti da inviarci',
          icon: 'file',
          answer: '<ul>' +
            '<li><b>MODULO RESO</b> <a href="https://tulero.blob.core.windows.net/tulero-docs/Tulero-ModuloReso.pdf" class="return-button btn btn-outline-secondary ml-1" target="_blank" download>Download PDF</a></li>' +
            '<li><b>DDT</b></li>' +
            '</ul>' +
            '<p>Scarichi il modulo di richiesta reso tramite il bottone qui sopra e lo compili nei campi necessari a seconda della tipologia di reso che intende effettuarci.</p>'
        },
        {
          question: 'Intestazione DDT',
          icon: 'file-text',
          answer: '<p>Ricordiamo che il DDT dovrà essere intestato come segue.</p>' +
            '<p><b>Destinatario:</b> Matheria srl, corso Svizzera 185, scala F, 10149, Torino (TO)</p>' +
            '<p><b>Indirizzo di spedizione:</b> Matheria srl, corso Svizzera 185, scala F, 10149, Torino (TO)</p>'
        },
        {
          question: 'Invio documenti',
          icon: 'mail',
          answer: 'Invii il modulo reso compilato insieme al DDT di spedizione all\'indirizzo email di seguito</br>' +
            '<a href="mailto:warranty@tulero.it" class="return-button btn btn-outline-secondary mt-1">INVIA MAIL</a>'
        },
        {
          question: 'Imballaggio degli articoli',
          icon: 'package',
          answer: '<ul>' +
            '<li><p><b>Resi non conformi:</b> abbia cura di consegnare la merce con l’imballo originale non danneggiato, senza che vi siano apposte etichette per la spedizione (utilizzare una scatola aggiuntiva come imballo esterno).</p></li>' +
            '<li><p><b>Resi carcassa bombole:</b> abbia cura di consegnare la merce ben imballata in una scatola di cartone</p></li>' +
            '</ul>'
        },
        {
          question: 'Ricambi',
          icon: 'package',
          answer: '<ul>' +
            '<li><p><b>Resi Standard:</b> La merce deve essere visionata al momento della consegna e deve essere accettata con riserva nel caso in cui presenti dei danni visibili. Nl caso di danni causati dal corriere, Matheria Srl risponderà solo nel caos in cui il cliente abbia accettato con riserva durante la consegna.</p></li>' +
            '</ul>'
        },
        {
          question: 'Materiale escluso dai resi standard',
          icon: 'package',
          answer: '<p>Il diritto di reso non può essere applicato.</p>' +
            '<ul>' +
            '<li><b>Batterie</b></li>' +
            '<li><b>Serbatoi GPL</b></li>' +
            '<li><b>Lubrificanti</b></li>' +
            '<li><b>Codici Originali</b></li>' +
            '</ul>' +
            '<p>Scarichi il modulo di richiesta reso tramite il bottone qui sopra e lo compili nei campi necessari a seconda della tipologia di reso che intende effettuarci.</p>'
        },
        {
          question: 'Carrozzeria',
          icon: 'package',
          answer: '<p><b>Reso Standard: </b>' +
            '            \I resi standard devono essere richiesti entro i 5 giorni dalla data dell’ordine. La merce deve essere visionata al momento della consegna e deve essere accettata con riserva. In caso di mancata accettazione con riserva, il reso non verrà accettato. Il prodotto di carrozzeria è escluso da qualsiasi tipo di reso e di garanzia qualora sia stato trattato dall’officina con coloranti e affini che ne modificano la struttura.</p>\ \n </p>' +
            '<p><b>Garanzia: </b>\n' +
            '\n' +
            'Le richieste di garanzia verranno accettate solo entro i 7 gg dalla data di consegna dell’ordine, visto che la carrozzeria è priva di parti meccaniche.</p>'
        },
        {
          question: 'Codici Prasco',
          icon: 'package',
          answer: '<p><b>Reso Standard: </b>' +
            '            \I resi standard devono essere richiesti entro i 5 giorni dalla data dell’ordine. La merce deve essere visionata al momento della consegna e deve essere accettata con riserva nel caso in cui l’imballo arrivi danneggiato.</p>\ \n </p>' +
            '<p><b>Garanzia: </b>\n' +
            '\n' +
            'Le richieste di garanzia verranno accettate entro 1 anno dalla data dell’ordine.</p>'
        },
        {
          question: 'Spedizione degli articoli',
          icon: 'truck',
          answer: '<p>Il ritiro della merce e le relative spese di spedizione sono a carico di Tulero.</p>' +
            '<p>Una volta ricevuta la documentazione via email, vi confermeremo l\'avvenuto incarico al corriere</p>',
          alert: {
            type: 'secondary',
            message: 'Le ricordiamo che verranno accettate richieste di resi solo entro 15gg di calendario dalla data dell’ordine, fatta eccezione per i resi in garanzia.'
          }
        },
      ]
    }
  }

  ngOnDestroy(): void {

  }

}
